/**
 * Display helpers for the web links a coach keeps on a prospect's profile
 * (`features/dashboard/sections/players/links`). Not to be confused with `prospectLinks.ts`,
 * which builds in-app URLs to a prospect.
 */

/**
 * Host and path, without the scheme or a leading "www.", so a list of PBR pages reads as
 * addresses rather than as a column of "https://". Falls back to the raw value.
 */
export function formatLinkForDisplay(url: string): string {
  try {
    const parsed = new URL(url);
    const host = parsed.host.replace(/^www\./i, "");
    const path = parsed.pathname === "/" ? "" : parsed.pathname;
    return `${host}${path}`;
  } catch {
    return url;
  }
}

/**
 * The API only stores http/https links. Checked again before rendering an href, so nothing else
 * (a `javascript:` value from a bad import, say) can ever become a clickable link.
 */
export const isWebUrl = (url: string): boolean => /^https?:\/\//i.test(url);
